import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import renderWithTheme from './env/renderWithTheme';
import ConnectedApp from './ConnectedApp';

let env;
let envLevel;
let service;
let allowedTracingUrls;
if (window.location.hostname.match(/(claims-validation)/i)) {
    env = 'prod';
    envLevel = 'production-validation';
    service = 'validation-client-web-prod';
    allowedTracingUrls = ['https://claims-validation.allstate.com'];
} else if (window.location.hostname.match(/(pi-validation)/i)) {
    env = 'nonprod';
    envLevel = 'pre-production';
    service = 'validation-client-web-pre-prod';
    allowedTracingUrls = ['https://pi-validation.allstate.com'];
} else {
    const [ddEnv] = window.location.hostname.split('.');
    env = 'nonprod';
    envLevel = ddEnv;
    service = `validation-client-${ddEnv}`;
    allowedTracingUrls = [`https://validation-client-${ddEnv}.auth-platform-sandbox.allstate.com`];
}

const build = process.env.BUILD_NUMBER ? process.env.BUILD_NUMBER : '0-development';

datadogRum.init({
    applicationId: '3547c2c9-e32a-44af-841c-676a1cf579dc',
    clientToken: 'pub49c3b70bda026195a4e66f4e1c84de4c',
    site: 'datadoghq.com',
    sessionSampleRate: 100,
    service,
    allowedTracingUrls,
    env,
    version: `1.0.${build}`,
    trackUserInteractions: true,
});
datadogRum.addRumGlobalContext('envlevel', envLevel);
datadogRum.addRumGlobalContext('barometerit', '0418000014JN');

datadogRum.startSessionReplayRecording();

renderWithTheme(<ConnectedApp />);
